import { render, staticRenderFns } from "./AddMedia.vue?vue&type=template&id=a7a38872&scoped=true&"
import script from "./AddMedia.vue?vue&type=script&lang=js&"
export * from "./AddMedia.vue?vue&type=script&lang=js&"
import style0 from "./AddMedia.vue?vue&type=style&index=0&id=a7a38872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a38872",
  null
  
)

export default component.exports